function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-9{fill:#edeceb;}.cls-12,.cls-2{fill:#e5e4e3;}.cls-17,.cls-3,.cls-8{fill:#fff;}.cls-10,.cls-13,.cls-14,.cls-4,.cls-5,.cls-6,.cls-7{fill:none;}.cls-4,.cls-6,.cls-9{stroke:#301f27;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-11,.cls-12,.cls-13,.cls-15,.cls-16,.cls-19,.cls-5,.cls-8{stroke:#231f20;}.cls-13,.cls-17,.cls-6{stroke-width:2px;}.cls-14,.cls-7{stroke:#939598;}.cls-7{stroke-dasharray:1.97 1.97;}.cls-10{stroke:#a7a9ac;}.cls-10,.cls-14{stroke-dasharray:2;}.cls-11{fill:#fb0;}.cls-15{fill:#ff4b57;}.cls-16{fill:#301f27;}.cls-17,.cls-18{stroke:#301e26;}.cls-18,.cls-19{fill:#231f20;}.cls-20,.cls-21,.cls-22{fill:#f7971d;}.cls-20{opacity:0.4;}.cls-21{opacity:0.5;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-1",
  cx: 284.62,
  cy: 181.56,
  rx: 284.81,
  ry: 91.33,
  transform: "translate(-49.8 135.36) rotate(-24.67)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-2",
  cx: 265.35,
  cy: 179.36,
  rx: 266.97,
  ry: 71.64,
  transform: "translate(-52.05 136.48) rotate(-26.36)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-3",
  cx: 267.81,
  cy: 178.89,
  rx: 213.43,
  ry: 56.76,
  transform: "translate(-52.28 143.28) rotate(-27.39)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-4",
  cx: 270.09,
  cy: 158.09,
  rx: 273.99,
  ry: 89.88,
  transform: "translate(-42.86 156.23) rotate(-30)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-5",
  cx: 293.85,
  cy: 170.54,
  rx: 184.11,
  ry: 58.44,
  transform: "translate(-45.52 154.33) rotate(-27.39)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-5",
  cx: 301.04,
  cy: 166.81,
  rx: 176.01,
  ry: 56.76,
  transform: "translate(-42.99 157.21) rotate(-27.39)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-6",
  cx: 278.08,
  cy: 180.3,
  rx: 273.99,
  ry: 87.86,
  transform: "translate(-49.87 132.52) rotate(-24.67)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-7",
  cx: 349.49,
  cy: 294.24,
  rx: 30.63,
  ry: 7.04,
  transform: "translate(-100.3 214.16) rotate(-30)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-7",
  cx: 212.36,
  cy: 65.32,
  rx: 30.63,
  ry: 7.04,
  transform: "translate(-4.21 114.93) rotate(-30)"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M60.74,316.17A16.71,16.71,0,0,1,32,327.73a88.13,88.13,0,0,0,14.64-5.34,88.88,88.88,0,0,0,14-7.93A16,16,0,0,1,60.74,316.17Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M60.65,314.46a88.88,88.88,0,0,1-14,7.93A88.13,88.13,0,0,1,32,327.73a16.74,16.74,0,0,1-4.66-11.56,16.72,16.72,0,0,1,30.24-9.84A16.54,16.54,0,0,1,60.65,314.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M27.73,319.91A16.37,16.37,0,0,0,32,327.73c-5.68,1.46-9.71,1.52-10.47-.13S23.23,323.13,27.73,319.91Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M60.65,314.46a16.54,16.54,0,0,0-3.11-8.13c5.1-1.19,8.67-1.15,9.38.4S65.17,311.22,60.65,314.46Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 218.12,
  cy: 145.86,
  r: 12.87
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-10",
  cx: 218.9,
  cy: 146.02,
  r: 24.52
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-9",
  cx: 361.05,
  cy: 53.75,
  r: 11.57
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-11",
  cx: 152.86,
  cy: 313.99,
  r: 11.57
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-12",
  cx: 143.3,
  cy: 308.23,
  r: 5.78
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-13",
  x1: 206.66,
  y1: 53.75,
  x2: 358.01,
  y2: 306.64
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-10",
  cx: 45.62,
  cy: 316.62,
  r: 45.12
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-11",
  cx: 84.74,
  cy: 292.25,
  r: 5.78
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-12",
  cx: 370.24,
  cy: 48.59,
  r: 5.78
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-14",
  cx: 45.62,
  cy: 316.16,
  r: 31.91
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M459.88,74.22a92.84,92.84,0,0,0-16.15,3.29q-2.5.72-5.06,1.59a102.07,102.07,0,0,0-17.94,8,23,23,0,0,1,39.15-12.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M466.36,92.23a7.4,7.4,0,0,1-.08.81l-.49-.45Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M466.36,92.23l-.57.36.49.45a23,23,0,0,1-10,16.36,95,95,0,0,1-15-6.32q-2.31-1.18-4.65-2.54a103.37,103.37,0,0,1-16-11.31,18.87,18.87,0,0,1,.2-2.15,102.07,102.07,0,0,1,17.94-8q2.55-.87,5.06-1.59a92.84,92.84,0,0,1,16.15-3.29,22.84,22.84,0,0,1,6.57,16.08C466.45,91,466.42,91.59,466.36,92.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M456.25,109.4A23,23,0,0,1,420.5,90.3c0-.36,0-.72,0-1.07a103.37,103.37,0,0,0,16,11.31q2.34,1.35,4.65,2.54A95,95,0,0,0,456.25,109.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M426.87,106.16c-10.51,1.36-18.22.09-19.58-3.89-1.29-3.79,3.5-9.16,11.87-14.27.51-.31,1-.62,1.57-.92a18.87,18.87,0,0,0-.2,2.15c0,.35,0,.71,0,1.07A22.86,22.86,0,0,0,426.87,106.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M466.36,92.23c.06-.64.09-1.28.09-1.93a22.84,22.84,0,0,0-6.57-16.08c9.58-1,16.5.35,17.78,4.1S474.38,87.23,466.36,92.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M430.07,71.64a22.93,22.93,0,0,0-9.34,15.44,18.87,18.87,0,0,0-.2,2.15c-.47-.4-.93-.82-1.37-1.23-7.22-6.63-10.87-12.82-8.87-16.29S420.11,68.32,430.07,71.64Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M474.66,108.88c-2,3.45-9.12,3.4-18.41.52a23,23,0,0,0,10-16.36C473.17,99.5,476.61,105.49,474.66,108.88Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-16",
  cx: 190.61,
  cy: 198.02,
  r: 1.52
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-5",
  x1: 90.74,
  y1: 132.99,
  x2: 190.61,
  y2: 198.02
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-17",
  x: 47.67,
  y: 79.82,
  width: 42.76,
  height: 83.36,
  rx: 3.75
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-18",
  x: 56.49,
  y: 156.54,
  width: 25.44,
  height: 2.8,
  rx: 1.4
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-19",
  d: "M81.93,79.82v2.6a1.44,1.44,0,0,1-1.45,1.41H57.94a1.44,1.44,0,0,1-1.45-1.41v-2.6Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-20",
  x: 61.16,
  y: 125.72,
  width: 16.09,
  height: 16.09,
  rx: 8.05,
  transform: "translate(114.86 -9.76) rotate(45)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-21",
  x: 62.75,
  y: 127.39,
  width: 12.74,
  height: 12.74,
  rx: 6.37,
  transform: "translate(114.83 -9.7) rotate(45)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-22",
  x: 64.48,
  y: 129.04,
  width: 9.28,
  height: 9.28,
  rx: 4.64,
  transform: "translate(114.77 -9.72) rotate(45)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-17",
  x: 416.99,
  y: 181.56,
  width: 42.76,
  height: 83.36,
  rx: 3.75
}), /*#__PURE__*/React.createElement("polygon", {
  points: "447.37 226.57 447.37 231.76 438.54 222.93 429.68 231.78 429.67 231.77 429.67 226.6 435.94 220.33 435.94 220.33 438.53 217.73 447.37 226.57"
})));

var SvgSolarSystemImage = function SvgSolarSystemImage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 546.26 362.25",
    ref: svgRef
  }, props), _ref2, title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSolarSystemImage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/solarSystemImage.21bcdbe2.svg";
export { ForwardRef as ReactComponent };